import { query } from '@/utils/request';

// 收入明细分析（单月）
export async function getMonthlyIncomeList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/income-details-monthly', {
    method: 'POST',
    data,
  });
}

// 收入明细分析（累计）
export async function getTotalIncomeList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/income-details-total', {
    method: 'POST',
    data,
  });
}

// 药品指标分析（单月）
export async function getMonthlyDrugList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/drug-indicators-monthly', {
    method: 'POST',
    data,
  });
}

// 药品指标分析（累计）
export async function getTotalDrugList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/drug-indicators-total', {
    method: 'POST',
    data,
  });
}

// 病案指标分析（单月）
export async function getMonthlyCaseList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/case-indicators-monthly', {
    method: 'POST',
    data,
  });
}

// 病案指标分析（累计）
export async function getTotalCaseList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/case-indicators-total', {
    method: 'POST',
    data,
  });
}

// 均次费用分析（单月）
export async function getMonthlyExpenseList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/avg-expense-monthly', {
    method: 'POST',
    data,
  });
}

// 均次费用分析（累计）
export async function getTotalExpenseList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/avg-expense-total', {
    method: 'POST',
    data,
  });
}

// 历年收入分析
export async function getAnnualIncomeList(data) {
  return query('/zlb/budget/ep/medical/income-analysis/annual-income', {
    method: 'POST',
    data,
  });
}

// 收入分析统计范围查询
export async function getStatisticalScope(data) {
  return query('/zlb/budget/ep/medical/basic-data/statistical-scope', {
    method: 'POST',
    data,
  });
}

// 收入明细分析（单月）导出
export async function exportMonthlyIncomeDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/income-details-monthly/export/submit', {
    method: 'POST',
    data,
  });
}

// 收入明细分析（累计）导出
export async function exportTotalIncomeDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/income-details-total/export/submit', {
    method: 'POST',
    data,
  });
}

// 药品指标分析（单月）导出
export async function exportMonthlyDrugDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/drug-indicators-monthly/export/submit', {
    method: 'POST',
    data,
  });
}

// 药品指标分析（累计）导出
export async function exportTotalDrugDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/drug-indicators-total/export/submit', {
    method: 'POST',
    data,
  });
}

// 病案指标分析（单月）导出
export async function exportMonthlyCaseDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/case-indicators-monthly/export/submit', {
    method: 'POST',
    data,
  });
}

// 病案指标分析（累计）导出
export async function exportTotalCaseDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/case-indicators-total/export/submit', {
    method: 'POST',
    data,
  });
}

// 均次费用分析（单月）导出
export async function exportMonthlyExpenseDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/avg-expense-monthly/export/submit', {
    method: 'POST',
    data,
  });
}

// 均次费用分析（累计）导出
export async function exportTotalExpenseDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/avg-expense-total/export/submit', {
    method: 'POST',
    data,
  });
}

// 历年收入分析导出
export async function exportAnnualIncomeDetail(data) {
  return query('/zlb/budget/ep/medical/income-analysis/annual-income/export/submit', {
    method: 'POST',
    data,
  });
}